import { handleActions } from 'redux-actions'

import {
  setClinicianUserRoles,
  setCliniciansList,
  setCliniciansLoader,
  setCliniciansModalLoader
} from 'src/store/modules/admin/clinicians'

const initialState = {
  cliniciansList: [],
  cliniciansLoader: false,
  cliniciansModalLoader: false,
  clinicianUserRoles: []
}

export default handleActions(
  {
    [setCliniciansList](state, { payload: cliniciansList }) {
      return {
        ...state,
        cliniciansList
      }
    },
    [setCliniciansLoader](state, { payload: cliniciansLoader }) {
      return {
        ...state,
        cliniciansLoader
      }
    },
    [setCliniciansModalLoader](state, { payload: cliniciansModalLoader }) {
      return {
        ...state,
        cliniciansModalLoader
      }
    },
    [setClinicianUserRoles](state, { payload: clinicianUserRoles }) {
      return {
        ...state,
        clinicianUserRoles
      }
    }
  },
  initialState
)
